import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";


export const useCoinSeriesStore
    = defineStore('coinSeriesStore', () => {

    const coinsEndpoint = environment.appConfig.baseApiUrl + "coins/series";


    const crud = useCrudStore(coinsEndpoint);

    async function loadCoinSeries(productId) {
        console.log("loadCoinSeries");
        crud.startLoading();
        try {
            const resp = await httpClient.get(coinsEndpoint, {params: {product_id: productId} });
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            console.log('loaded data',  resp.data.series )
            crud.addItems(resp.data.series);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        loadCoinSeries,
    }
});
